var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    { attrs: { bus: _vm.busModal, "max-width": "80vw" } },
    [
      _c("Title", { attrs: { title: "Vídeos" } }),
      _vm._l(_vm.lista, function(item, index) {
        return _c(
          "Card",
          { key: item.title, staticClass: "mb-10", attrs: { secondary: "" } },
          [
            item.title
              ? _c("p", { staticClass: "subtitle" }, [
                  _vm._v(" " + _vm._s(item.title) + " ")
                ])
              : _vm._e(),
            item.description
              ? _c("p", { staticClass: "text-sm" }, [
                  _vm._v(" " + _vm._s(item.description) + " ")
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center",
                staticStyle: { "min-height": "50vh" }
              },
              [
                _c("video", {
                  ref: "video-" + index,
                  refInFor: true,
                  staticClass: "elevation-3",
                  staticStyle: { "max-width": "80%", margin: "auto" },
                  attrs: {
                    src: item.url,
                    controls: "",
                    controlsList: "nodownload"
                  }
                })
              ]
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }